import React, { useMemo } from 'react';
import CustomModal from '../CustomModal/CustomModal';
import DataTable from '../DataTable';
import moment from 'moment';
import { iconArray } from '../../pages/ExamReport/iconArray';
import { Button } from 'react-bootstrap';

const IncidentListingModal = ({
  showIncidentDetailsModal,
  setShowIncidentDetailsModal,
  incidents,
  selectedItemName,
}) => {
  const categoryColors = {
    drivedownload: 'rgb(254, 195, 190)',
    contentdelivery: 'rgb(224,224,224)',
    contentprocess: 'rgb(255,224,143)',
    entryofcandidates: 'rgb(203,235,174)',
    registration: 'rgb(179,218,244)',
    aadharauthentication: 'rgb(187,211,218)',
    examcommencement: 'rgb(223,194,238)',
    allowedcandidateslogin: 'rgb(121,159,229)',
    examcompletion: 'rgb(144,132,219)',
    lockunlockincidents: 'rgb(122,234,203)',
  };

  const colorMapping = [
    { keyword: 'server', color: 'rgb(26,26,26)' },
    { keyword: 'administrative', color: 'rgb(33,90,108)' },
    { keyword: 'aadhar', color: 'rgb(117,57,0)' },
    { keyword: 'node', color: 'rgb(71,55,33)' },
    { keyword: 'syncerror', color: 'rgb(36,112,226)' },
    { keyword: 'power', color: 'rgb(18,115,75)' },
    { keyword: 'wlan', color: 'rgb(177,23,2)' },
    { keyword: 'internetissue', color: 'rgb(228,139,243)' },
    { keyword: 'law', color: 'rgb(9,83,168)' },
    { keyword: 'cybersecurity', color: 'rgb(90,50,133)' },
    { keyword: 'training', color: 'rgb(32,99,199)' },
  ];

  const incidentsCount = incidents.length;

  const shiftColors = {
    shift1: 'rgb(203,235,174)',
    shift2: 'rgb(179,218,244)',
    shift3: 'rgb(255,224,143)',
  };

  const columns = useMemo(() => [
    {
      Header: 'Date',
      accessor: 'date',
      disableSortBy: true,
      Cell: ({ value }) => {
        return moment(value).format('DD/MM/YYYY');
      },
    },
    {
      Header: 'Shift',
      accessor: 'shift',
      disableSortBy: true,
      Cell: ({ value }) => {
        const normalizedCategory = value?.toLowerCase();

        const cellStyle = {
          backgroundColor: shiftColors[normalizedCategory] || 'transparent',
          color: 'black',
          fontWeight: 'normal',
          cursor: 'auto',
        };
        return (
          <Button className='btn-sm' variant='primary' style={cellStyle}>
            {value}
          </Button>
        );
      },
    },
    {
      Header: 'Exam',
      accessor: 'exam',
      disableSortBy: true,
    },
    {
      Header: 'Lan',
      accessor: 'lan',
      disableSortBy: true,
    },
    {
      Header: 'Center Name',
      accessor: 'center_name',
      disableSortBy: true,
    },
    {
      Header: 'City',
      accessor: 'city',
      disableSortBy: true,
    },
    {
      Header: 'Zone',
      accessor: 'zone',
      disableSortBy: true,
    },
    {
      Header: 'State',
      accessor: 'state',
      disableSortBy: true,
    },
    {
      Header: 'Time of Issue/Value',
      accessor: 'time_of_issue',
      disableSortBy: true,
      Cell: ({ value }) => {
        if (moment(value).isValid()) {
          return <div>{moment(value).format('HH:mm:ss')}</div>;
        } else {
          return value;
        }
      },
    },
    {
      Header: 'Stages of Exam',
      accessor: 'stages_of_exam',
      disableSortBy: true,
      Cell: ({ value, column }) => {
        const normalizedCategory = value
          ?.toLowerCase()
          .replace(/[^a-z0-9]/g, '');

        const cellStyle = {
          backgroundColor: categoryColors[normalizedCategory] || 'transparent',
          color: 'black',
          fontWeight: 'normal',
          cursor: 'auto',
        };

        return (
          <Button className='btn-sm' variant='primary' style={cellStyle}>
            {value}
          </Button>
        );
      },
    },
    {
      Header: 'Reason Category',
      accessor: 'reason_category',
      disableSortBy: true,
      Cell: ({ value, column }) => {
        const cleanedReason = value?.trim().toLowerCase().replace(/\s+/g, ''); // ✅ Remove spaces

        const match = colorMapping.find(({ keyword }) => {
          return cleanedReason?.includes(keyword);
        });

        const bgColor = match ? match.color : 'transparent'; // Default gray color
        const cellStyle = {
          backgroundColor: bgColor,
          padding: '8px',
          borderRadius: '5px',
          textAlign: 'center',
          width: '165x',
          color:
            value && value.length > 0 && bgColor !== 'transparent'
              ? 'White'
              : 'Black',
        };

        return (
          <Button className='btn-sm' variant='primary' style={cellStyle}>
            {value}
          </Button>
        );
      },
    },
    {
      Header: 'Type of Issue',
      accessor: 'type_of_issue',
      disableSortBy: true,
      Cell: ({ value }) => {
        return (
          <div
            style={{
              backgroundColor:
                value && value.length > 0
                  ? value === 'Major'
                    ? 'Red'
                    : 'Blue'
                  : 'transparent',
              padding: '8px',
              borderRadius: '5px',
              textAlign: 'center',
              width: '165x',
              color:
                value && value.length > 0 && ['Major', 'Minor'].includes(value)
                  ? 'White'
                  : 'Black',
            }}
          >
            {value}
          </div>
        );
      },
    },
    {
      Header: 'Remarks of ECA',
      accessor: 'remarks_of_eca',
      disableSortBy: true,
    },

    {
      Header: 'Remarks of RRB',
      accessor: 'remarks_of_rrb',
      disableSortBy: true,
    },
  ]);

  return (
    <div>
      <CustomModal
        show={showIncidentDetailsModal}
        onHide={setShowIncidentDetailsModal}
        hasSave={false}
        hasActions={false}
        modalHeading={`${selectedItemName ? selectedItemName : ''} Incidents`}
        size='xl'
        centered
        hadBodyPadding
        scrollable
      >
        <DataTable
          cardClass='border-0 shadow-none'
          columns={columns}
          data={incidents.length > 0 ? incidents : []}
          totalRecords={incidentsCount}
          tableHooks={() => {}}
          defaultPageLength={[25, 50, 100]}
          manual={true}
          align='table-vcenter'
          hidePagination
          hideSearch
        />
      </CustomModal>
    </div>
  );
};

export default IncidentListingModal;
